import React from "react"

import styles from "./index.module.scss"

export type UserHeaderProps = {
  title: string
  onClickBack?: () => void
}

const UserHeader: React.FC<UserHeaderProps> = ({ title, onClickBack }) => (
  <div className={styles.header}>
    <div className={styles.headerInner}>
      {onClickBack && (
        <button className={styles.back} onClick={onClickBack}>
          <i className="fas fa-chevron-left"></i>
        </button>
      )}
      <div className={styles.title}>{title}</div>
    </div>
  </div>
)

export default UserHeader
